module.exports = __webpack_public_path__ + "img/TM-KGX.45e7a63b.png";